import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CarPark } from './CarPark'
import EditCar from './components/CarParkTable/EditCar'
import { SimpleVehicleProps } from '../types/types'
import Dialog from '../../../../../components/modal/Dialog'
import CarParkTableColumns from './components/CarParkTable/CarParkTableColumns'
import { useMediaQuery } from '../../../v3/hooks/useMediaQuery'
import { VisibilityState } from '@tanstack/react-table'
import CarInformation from './components/CarParkTable/CarInformation'
import { useChosenCompany, useUser } from '../../../../../context/UserProvider'

const CarParkWrapper = () => {
  const navigate = useNavigate()
  const [showCommentModal, setShowCommentModal] = useState(false)
  const [showCarInformationModal, setShowCarInformationModal] = useState(false)
  const [showEditCarModal, setShowEditCarModal] = useState(false)
  const [selectedCar, setSelectedCar] = useState<SimpleVehicleProps | null>(
    null,
  )

  const isDesktop = useMediaQuery('(min-width: 768px)')
  const modalSize = useMediaQuery('(min-width: 640px)')

  const columns = useMemo(
    () => CarParkTableColumns(),
    [setShowCommentModal, setShowEditCarModal, setSelectedCar],
  )

  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({})

  useEffect(() => {
    setColumnVisibility({
      make: isDesktop,
      year: isDesktop,
      driverName: isDesktop,
      status: isDesktop,
      actualDeliveryDate: isDesktop,
      plannedReturnDate: isDesktop,
      contractMileage: isDesktop,
      nextInspectionDate: isDesktop,
      replacementCar: isDesktop,
    })
  }, [isDesktop])

  return (
    <>
      <CarPark
        columns={columns}
        columnVisibility={columnVisibility}
        onColumnVisibilityChange={setColumnVisibility}
        openEdit={(car) => {
          setSelectedCar(car)
          setShowEditCarModal(true)
        }}
        openInfo={(car) => {
          setSelectedCar(car)
          setShowCarInformationModal(true)
        }}
        navigateToCar={(car) => {
          const id = (car as any).accountNo ?? (car as any).budgetNo
          const type = (car as any).accountNo ? 'account' : 'budget'
          navigate(`/cars/${id}?type=${type}`)
        }}
      />
      {/* <Dialog
        width={'525px'}
        open={showCommentModal as any}
        //@ts-ignore
        onOpenChange={() => setShowCommentModal(false)}
      >
        <AddComment car={selectedCar as SimpleVehicleProps} />
      </Dialog> */}
      <Dialog
        width={modalSize ? '525px' : '300px'}
        open={showEditCarModal as any}
        //@ts-ignore
        onOpenChange={() => setShowEditCarModal(false)}
      >
        <EditCar
          car={selectedCar}
          setShowEditCar={() => setShowEditCarModal(false)}
        />
      </Dialog>
      <Dialog
        width={modalSize ? '525px' : '300px'}
        open={showCarInformationModal as any}
        //@ts-ignore
        onOpenChange={() => setShowCarInformationModal(false)}
      >
        <CarInformation
          car={selectedCar}
          isOpen={showCarInformationModal}
          setShowCarInformation={() => setShowCarInformationModal(false)}
        />
      </Dialog>
    </>
  )
}

export default CarParkWrapper
